export const GRAMMAR_SLOT_ROLES = [
  'subject',
  'auxiliary',
  'verb',
  'ending',
  'negator',
  'noun',
  'adjective',
  'adverb',
  'object',
  'complement',
  'determiner',
  'adverbial',
  'question-word',
  'connector',
  'fixed',
] as const;

export type GrammarSlotRoleType = (typeof GRAMMAR_SLOT_ROLES)[number];
